import { BulkRequestSubmitConfirmModal } from "./BulkRequestSubmitConfirmModal";
import { show } from "@ebay/nice-modal-react";
import type { BulkRequestRecord } from "api/clients/useBulkRequestQuery";

/**
 * Display a confirmation modal with a summary of submission update.
 * @param setConfirming Set Submit Button Loading To avoid accidental double submit.
 * @returns Promise representing dialog lifetime.
 */
export async function showBulkRequestSubmitConfirmModal(
    setConfirming: (x: boolean) => void,
    submit: () => Promise<void>,
    submitData: BulkRequestRecord[],
    invalidCount: number,
) {
    return await show(BulkRequestSubmitConfirmModal, { setConfirming, submit, submitData, invalidCount });
}
